<template>
   <div class="rent-a-car-age-selection">
      <div class="selection-container">
         <UIRadioButton :label="$t('rentacarSearchForm_lblDefaultAge')" name="ageSelection" id="ageRange" native-value="range" v-model="selectionMode" />

         <div class="manual-option-wrapper">
            <UIRadioButton :label="$t('rentacarSearchForm_lblManuelAge')" name="ageSelection" id="ageManual" native-value="manual" v-model="selectionMode" />

            <!-- Manuel Giriş Input - Diğer radio button ile aynı satırda -->
            <div v-if="selectionMode === 'manual'" class="manual-input-wrapper">
               <input ref="manualAgeInput" type="number" :value="manualAge" @input="handleAgeInput" @keyup.enter="handleEnterKey" min="18" max="99" />
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import UIRadioButton from "@/components/unitary/form2/UIRadioButton.vue";

export default {
   name: "RentACarAgeSelection",
   components: {
      UIRadioButton,
   },
   props: {
      options: {
         type: Array,
         required: true,
      },
      value: {
         type: String,
         default: "",
      },
   },
   data() {
      return {
         selectionMode: this.getInitialMode(),
         manualAge: this.getInitialAge(),
      };
   },
   computed: {
      isManualAgeValid() {
         return this.manualAge !== null && this.manualAge >= 18 && this.manualAge <= 99;
      },
      isAgeInDefaultRange() {
         return this.manualAge !== null && this.manualAge >= 25 && this.manualAge <= 65;
      },
   },
   mounted() {
      if (this.selectionMode === "manual") {
         setTimeout(() => {
            if (this.$refs.manualAgeInput) {
               this.$refs.manualAgeInput.focus();
            }
         }, 50);
      }
   },
   methods: {
      getInitialMode() {
         return !this.value || this.value === "25-65" ? "range" : "manual";
      },
      getInitialAge() {
         if (this.value && this.value !== "25-65") {
            const age = parseInt(this.value);
            if (!isNaN(age)) {
               return age;
            }
         }
         return null;
      },
      handleAgeInput(event) {
         const value = event.target.value;
         this.manualAge = value === "" ? null : parseInt(value);
      },
      handleEnterKey() {
         if (this.isManualAgeValid) {
            if (this.isAgeInDefaultRange) {
               this.selectionMode = "range";
            } else {
               this.$emit("close");
            }
         }
      },
   },
   watch: {
      value: {
         handler() {
            this.selectionMode = this.getInitialMode();
            this.manualAge = this.getInitialAge();
         },
         immediate: false,
      },
      selectionMode: {
         handler(newMode) {
            if (newMode === "range") {
               const defaultOption = {
                  name: this.$i18n.t("rentacarSearchForm_lblDefaultAge"),
                  value: "25-65",
               };
               this.$emit("input", defaultOption.value);
               this.$emit("update-selection", defaultOption);
               this.$emit("close");
            } else if (newMode === "manual") {
               setTimeout(() => {
                  if (this.$refs.manualAgeInput) {
                     this.$refs.manualAgeInput.focus();
                  }
               }, 50);
            }
         },
      },
      manualAge: {
         handler(newAge) {
            if (this.selectionMode === "manual" && this.isManualAgeValid) {
               if (this.isAgeInDefaultRange) {
                  this.selectionMode = "range";
               } else {
                  const manualOption = {
                     name: String(newAge),
                     value: String(newAge),
                  };
                  this.$emit("input", manualOption.value);
                  this.$emit("update-selection", manualOption);
               }
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.rent-a-car-age-selection {
   width: 100%;
   background-color: var(--container-bg);
   border-radius: 0.5rem;
   box-shadow: var(--gts-box-shadow);
   padding: 1.5rem 1rem;

   .selection-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .manual-option-wrapper {
         display: flex;
         align-items: center;
         gap: 1rem;
         min-height: 42px;

         .manual-input-wrapper {
            flex: 1;
            animation: slideInFromLeft 0.15s cubic-bezier(0.4, 0, 0.2, 1);

            input {
               width: 100%;
               height: 42px;
               padding: 0 0.75rem;
               border: 2px solid var(--gts-input-border-lighter);
               background-color: var(--gts-input-background-lighter);
               border-radius: 0.5rem;
               color: var(--txt-color);
               outline: none;
               font-size: var(--normal);

               &:focus {
                  border-color: var(--accent-primary);
                  // background-color: var(--accent-primary-lighter);
               }

               &::placeholder {
                  color: var(--gray-400);
               }
            }
         }
      }
   }
}

@keyframes slideInFromLeft {
   from {
      opacity: 0;
      transform: translateX(-20px);
   }
   to {
      opacity: 1;
      transform: translateX(0);
   }
}
</style>
